import config from '../constants/freshchat';

export default () => {
  const freshChatScript = document.createElement('script');
  freshChatScript.src = 'https://wchat.freshchat.com/js/widget.js';
  document.body.appendChild(freshChatScript);
  const current = config.negociostp || config.localhost;

  setTimeout(() => {
    if (window.fcWidget) {
      window.fcWidget.init(current);
    } else {
      // eslint-disable-next-line
      console.warn('The freshchat widget don\'t charge correctly');
    }
  }, 3000);
};
